module.exports = __webpack_public_path__ + "static/img/photo7.161cb4f3.jpg";